<div fxLayout="row" class="background">
  <div fxFlex="75" fxFlexOffset="12%">
    <section id="header">
      <h1 class="h1Header">{{ isEditMode ? 'EDICIÓN DE ENVÍO' : 'ENVÍO NUEVO' }}</h1>
    </section>

    <div fxLayout="row" class="tablaCom">
      <div fxFlex="120" fxFlexOffset="-25%">
        <mat-card class="mat-elevation-z0">
          <form
            [formGroup]="addressForm"
            (ngSubmit)="onSubmit()"
            class="address-form"
          >
            <!-- Estado del pedido - Solo información en modo edición -->
            <div *ngIf="isEditMode && orderStatus !== null" class="status-display" style="margin: 0 0 20px 0; padding: 16px; background-color: #f5f5f5; border-radius: 8px; border-left: 4px solid #2196f3;">
              <div style="display: flex; align-items: center; gap: 12px;">
                <mat-icon style="color: #2196f3;">info</mat-icon>
                <div>
                  <div style="font-weight: 500; color: #333; margin-bottom: 4px;">Estado actual del pedido</div>
                  <div style="font-size: 18px; font-weight: 600; color: #2196f3;">
                    {{ orderStatus! | particularOrderStatus }}
                  </div>
                </div>
              </div>
            </div>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Nombre del cliente</mat-label>
              <input
                matInput
                formControlName="personName"
                placeholder="Buscar o ingresar nombre"
                [matAutocomplete]="clientAutoComplete"
                (input)="filterClients($event)"
                (blur)="onClientInput()"
              />
              <mat-autocomplete #clientAutoComplete="matAutocomplete" (optionSelected)="onClientSelected($event.option.value)">
                <mat-option *ngFor="let client of filteredClients" [value]="client">
                  {{ client.dsNombreFantasia || client.dsRazonSocial }} - CUIT: {{ client.dsCUIT }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="addressForm.get('personName')?.hasError('required')"
              >
                El nombre es requerido
              </mat-error>
            </mat-form-field>
            <div class="address-item">
              <div class="address-content">
                <div class="address-fields-row">
                  <mat-form-field appearance="outline" class="address-main-field">
                    <mat-label>Dirección de retiro</mat-label>
                    <input
                      matInput
                      formControlName="pickupAddress"
                      placeholder="Ingrese la dirección de retiro"
                      [readonly]="!canEditAddresses()"
                      [class.readonly-field]="!canEditAddresses()"
                    />
                    <mat-error
                      *ngIf="
                        addressForm.get('pickupAddress')?.hasError('required')
                      "
                    >
                      La dirección de retiro es requerida
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="address-detail-field">
                    <mat-label>Detalle</mat-label>
                    <input
                      matInput
                      formControlName="pickupAddressDetail"
                      placeholder="Ej: piso, depto, referencia"
                      [readonly]="!canEditAddresses()"
                      [class.readonly-field]="!canEditAddresses()"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="address-actions">
                <button
                  mat-icon-button
                  type="button"
                  (click)="moveAddress('pickup', 'up')"
                  [disabled]="true"
                  matTooltip="Mover hacia arriba"
                >
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="moveAddress('pickup', 'down')"
                  [disabled]="!canEditAddresses()"
                  matTooltip="Mover hacia abajo"
                >
                  <mat-icon>arrow_downward</mat-icon>
                </button>
              </div>
            </div>

            <!-- Waypoints -->
            <div *ngIf="waypointsArray.length > 0" formArrayName="waypoints">
              <div class="waypoints-list">
                <div
                  *ngFor="
                    let waypoint of waypointsArray.controls;
                    let i = index
                  "
                  class="address-item"
                >
                  <div
                    class="address-content"
                    [formGroup]="getWaypointFormGroup(waypoint)"
                  >
                    <div class="address-fields-row">
                      <mat-form-field appearance="outline" class="address-main-field">
                        <mat-label>Parada {{ i + 1 }}</mat-label>
                        <input
                          matInput
                          formControlName="address"
                          [placeholder]="'Dirección de la parada ' + (i + 1)"
                          [readonly]="!canEditAddresses()"
                          [class.readonly-field]="!canEditAddresses()"
                        />
                        <mat-error
                          *ngIf="waypoint.get('address')?.hasError('required')"
                        >
                          La dirección es requerida
                        </mat-error>
                      </mat-form-field>
                      <mat-form-field appearance="outline" class="address-detail-field">
                        <mat-label>Detalle</mat-label>
                        <input
                          matInput
                          formControlName="addressDetail"
                          placeholder="Ej: piso, depto, referencia"
                          [readonly]="!canEditAddresses()"
                          [class.readonly-field]="!canEditAddresses()"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="actions-container">
                    <div class="address-actions">
                      <button
                        mat-icon-button
                        type="button"
                        (click)="moveWaypoint(i, 'up')"
                        [disabled]="i === 0 || !canEditAddresses()"
                        matTooltip="Mover hacia arriba"
                      >
                        <mat-icon>arrow_upward</mat-icon>
                      </button>
                      <button
                        mat-icon-button
                        type="button"
                        (click)="moveWaypoint(i, 'down')"
                        [disabled]="i === waypointsArray.length - 1 || !canEditAddresses()"
                        matTooltip="Mover hacia abajo"
                      >
                        <mat-icon>arrow_downward</mat-icon>
                      </button>
                    </div>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="removeWaypoint(i)"
                      type="button"
                      [disabled]="!canEditAddresses()"
                      matTooltip="Eliminar parada"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="address-item">
              <div class="address-content">
                <div class="address-fields-row">
                  <mat-form-field appearance="outline" class="address-main-field">
                    <mat-label>Dirección de entrega</mat-label>
                    <input
                      matInput
                      formControlName="deliveryAddress"
                      placeholder="Ingrese la dirección de entrega"
                      [readonly]="!canEditAddresses()"
                      [class.readonly-field]="!canEditAddresses()"
                    />
                    <mat-error
                      *ngIf="
                        addressForm.get('deliveryAddress')?.hasError('required')
                      "
                    >
                      La dirección de entrega es requerida
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="address-detail-field">
                    <mat-label>Detalle</mat-label>
                    <input
                      matInput
                      formControlName="deliveryAddressDetail"
                      placeholder="Ej: piso, depto, referencia"
                      [readonly]="!canEditAddresses()"
                      [class.readonly-field]="!canEditAddresses()"
                    />
                  </mat-form-field>
                </div>
              </div>
              <div class="address-actions">
                <button
                  mat-icon-button
                  type="button"
                  (click)="moveAddress('delivery', 'up')"
                  [disabled]="!canEditAddresses()"
                  matTooltip="Mover hacia arriba"
                >
                  <mat-icon>arrow_upward</mat-icon>
                </button>
                <button
                  mat-icon-button
                  type="button"
                  (click)="moveAddress('delivery', 'down')"
                  [disabled]="true"
                  matTooltip="Mover hacia abajo"
                >
                  <mat-icon>arrow_downward</mat-icon>
                </button>
              </div>
            </div>

            <div
              fxLayout="row"
              fxLayoutAlign="start center"
              style="margin-bottom: 8px; gap: 1rem"
            >
              <button
                mat-raised-button
                color="primary"
                type="button"
                (click)="calculateDistance()"
                [disabled]="loadingDistance"
                style="min-width: 180px"
              >
                Calcular distancia
              </button>

              <button
                mat-button
                color="primary"
                type="button"
                (click)="addWaypoint()"
                [disabled]="!canEditAddresses()"
              >
                <mat-icon>add_location_alt</mat-icon>
                Agregar parada intermedia
              </button>

              <div *ngIf="distance" class="distance-info-container">
                <div class="distance-info">
                  <mat-icon style="vertical-align: bottom"
                    >directions_car</mat-icon
                  >
                  <strong>Distancia total: {{ distance }} km</strong>
                </div>
                <div
                  *ngIf="waypoints.length > 0"
                  style="font-size: 0.9em; color: #666"
                >
                  <div>Ruta con {{ waypoints.length + 1 }} tramos</div>
                </div>
              </div>
            </div>

            <div class="double-fields">
              <div>
                <mat-label class="options-label">Plus:</mat-label>
                <div formGroupName="options" class="options-column">
                  <div class="option-item">
                    <mat-checkbox formControlName="idaVuelta">
                      Ida y vuelta (50% de descuento en el viaje de vuelta)
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="objetoFueraCaja">
                      Objeto fuera de la caja
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="lluvia">
                      Lluvia (Recargo por condiciones climáticas)
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="feriadoComun">
                      Feriados al 50%
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="feriadoEspecial">
                      Feriados al 100%
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="recargoFueraDeCiudad">
                      Recargo Fuera de Ciudad
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <mat-checkbox formControlName="iva">
                      IVA
                    </mat-checkbox>
                  </div>
                  <div class="option-item">
                    <div class="product-option">
                      <mat-checkbox formControlName="productos">
                        Comisión por Productos
                      </mat-checkbox>
                      <div
                        *ngIf="optionsFormGroup.get('productos')?.value"
                        class="product-cost-container"
                      >
                        <mat-form-field appearance="outline">
                          <input
                            matInput
                            type="number"
                            [formControl]="costoProductosControl"
                            placeholder="Costo de productos"
                            min="0"
                            step="0.01"
                          />
                          <span matSuffix>$</span>
                          <mat-error
                            *ngIf="
                              costoProductosControl.hasError('required') &&
                              (costoProductosControl.touched ||
                                addressForm.touched)
                            "
                          >
                            El costo de productos es requerido
                          </mat-error>
                          <mat-error
                            *ngIf="
                              costoProductosControl.hasError('min') &&
                              (costoProductosControl.touched ||
                                addressForm.touched)
                            "
                          >
                            El costo debe ser mayor o igual a 0
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="option-item">
                    <div class="scheduled-option">
                      <mat-checkbox formControlName="isScheduled" (change)="onScheduledChange($event)">
                        ¿Es programada?
                      </mat-checkbox>
                      <div
                        *ngIf="showDatePicker"
                        class="scheduled-date-container"
                      >
                        <mat-form-field appearance="outline">
                          <mat-label>Fecha programada</mat-label>
                          <input
                            matInput
                            [matDatepicker]="scheduledDatePicker"
                            [min]="minDate"
                            formControlName="scheduledAt"
                            placeholder="Seleccione fecha"
                            (click)="scheduledDatePicker.open()"
                          />
                          <mat-datepicker-toggle matSuffix [for]="scheduledDatePicker"></mat-datepicker-toggle>
                          <mat-datepicker #scheduledDatePicker></mat-datepicker>
                          <mat-error
                            *ngIf="
                              addressForm.get('options')?.get('scheduledAt')?.hasError('required') &&
                              (addressForm.get('options')?.get('scheduledAt')?.touched ||
                                addressForm.touched)
                            "
                          >
                            La fecha programada es requerida
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="option-item" *ngIf="isEditMode">
                    <div class="waiting-time-option">
                      <mat-checkbox formControlName="tiempoEspera">
                        Demora de 10 minutos
                      </mat-checkbox>
                      <div
                        *ngIf="optionsFormGroup.get('tiempoEspera')?.value"
                        class="waiting-time-container"
                      >
                        <mat-form-field appearance="outline">
                          <mat-label>Cantidad de demoras de 10 min</mat-label>
                          <input
                            matInput
                            type="number"
                            [formControl]="tiempoEsperaMinutosControl"
                            placeholder="Ej: 3 = 30 minutos"
                            min="1"
                            step="1"
                          />
                          <span matSuffix>x10min</span>
                          <mat-error
                            *ngIf="
                              tiempoEsperaMinutosControl.hasError('required') &&
                              (tiempoEsperaMinutosControl.touched ||
                                addressForm.touched)
                            "
                          >
                            La cantidad de demoras es requerida
                          </mat-error>
                          <mat-error
                            *ngIf="
                              tiempoEsperaMinutosControl.hasError('min') &&
                              (tiempoEsperaMinutosControl.touched ||
                                addressForm.touched)
                            "
                          >
                            Debe ser al menos 1 demora (10 minutos)
                          </mat-error>
                          <mat-error
                            *ngIf="
                              tiempoEsperaMinutosControl.hasError('pattern') &&
                              (tiempoEsperaMinutosControl.touched ||
                                addressForm.touched)
                            "
                          >
                            Solo números enteros positivos (ej: 1, 2, 3)
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cost-section">
                <div class="cost-left-column">
                  <!-- Notice about recalculation -->
                  <div class="recalculation-notice" style="margin: 0 0 15px 0; padding: 8px 12px; background-color: #ffebee; border-left: 4px solid #f44336; border-radius: 4px; font-size: 14px; color: #c62828;">
                    <mat-icon style="vertical-align: middle; margin-right: 8px; font-size: 18px; color: #f44336;">warning</mat-icon>
                    <strong>Importante:</strong> Si cambias las direcciones o las opciones de recargo
                    , debes volver a calcular las distancias y el costo.
                  </div>
                  
                  <div class="calculate-cost-container">
                    <button
                      mat-raised-button
                      color="primary"
                      type="button"
                      (click)="calculateCost()"
                      [disabled]="loadingCost || totalDistanceKm === 0"
                      style="min-width: 180px"
                    >
                      <span *ngIf="!loadingCost">Calcular costo</span>
                      <mat-spinner
                        *ngIf="loadingCost"
                        diameter="20"
                      ></mat-spinner>
                    </button>
                  </div>
                  
                  <!-- Calculated cost display (non-editable) -->
                  <mat-form-field appearance="outline" class="cost-field">
                    <mat-label>Costo Calculado</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="costo"
                      placeholder="Calcule el costo primero"
                      min="0"
                      step="0.01"
                      readonly
                    />
                    <span matSuffix>$</span>
                  </mat-form-field>
                  
                  <!-- Final cost input (editable) -->
                  <mat-form-field appearance="outline" class="cost-field">
                    <mat-label>Costo Final</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="finalCost"
                      placeholder="Ingrese el costo final del envío"
                      min="0"
                      step="0.01"
                    />
                    <span matSuffix>$</span>
                    <mat-error
                      *ngIf="addressForm.get('finalCost')?.hasError('required')"
                    >
                      El costo final es requerido
                    </mat-error>
                    <mat-error *ngIf="addressForm.get('finalCost')?.hasError('min')">
                      El costo final debe ser mayor o igual a 0
                    </mat-error>
                  </mat-form-field>

                  <!-- Final cost with IVA (calculated, disabled) -->
                  <mat-form-field appearance="outline" class="cost-field">
                    <mat-label>Costo Final con IVA</mat-label>
                    <input
                      matInput
                      type="number"
                      formControlName="finalCostWithIVA"
                      placeholder="Se calcula automáticamente"
                      readonly
                    />
                    <span matSuffix>$</span>
                  </mat-form-field>
                </div>
                
                <!-- Desglose detallado del costo a la derecha -->
                <div *ngIf="costBreakdown" class="cost-right-column">
                  <div class="cost-breakdown">
                    <h3>Desglose del costo</h3>
                    <div class="breakdown-item">
                      <span>Costo base:</span>
                      <span>${{costBreakdown.baseCost.toFixed(2)}}</span>
                    </div>
                    <div class="breakdown-item">
                      <span>Costo por km extra:</span>
                      <span>${{costBreakdown.extraKmsCost.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.roundTripDiscount > 0">
                      <div class="breakdown-item">
                        <span>Costo viaje de vuelta:</span>
                        <span>${{costBreakdown.returnTripCost.toFixed(2)}}</span>
                      </div>
                      <div class="breakdown-item discount">
                        <span>Descuento ida y vuelta:</span>
                        <span>-${{costBreakdown.roundTripDiscount.toFixed(2)}}</span>
                      </div>
                    </div>
                    <div *ngIf="costBreakdown.productFee > 0" class="breakdown-item">
                      <span>Comisión por productos:</span>
                      <span>${{costBreakdown.productFee.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.oversizeFee > 0" class="breakdown-item">
                      <span>Cargo por tamaño excesivo:</span>
                      <span>${{costBreakdown.oversizeFee.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.rainSurcharge > 0" class="breakdown-item">
                      <span>Recargo por lluvia:</span>
                      <span>${{costBreakdown.rainSurcharge.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.feriadoComunSurcharge > 0" class="breakdown-item">
                      <span>Feriados al 50%:</span>
                      <span>${{costBreakdown.feriadoComunSurcharge.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.feriadoEspecialSurcharge > 0" class="breakdown-item">
                      <span>Feriados al 100%:</span>
                      <span>${{costBreakdown.feriadoEspecialSurcharge.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.waitFee > 0" class="breakdown-item">
                      <span>Cargo por tiempo de espera:</span>
                      <span>${{costBreakdown.waitFee.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.recargoFueraDeCiudadSurcharge > 0" class="breakdown-item">
                      <span>Recargo fuera de ciudad:</span>
                      <span>${{costBreakdown.recargoFueraDeCiudadSurcharge.toFixed(2)}}</span>
                    </div>
                    <div class="breakdown-item total">
                      <span>{{ costBreakdown.ivaAmount > 0 ? 'Subtotal:' : 'Costo total:' }}</span>
                      <span>${{costBreakdown.totalCost.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.ivaAmount > 0" class="breakdown-item">
                      <span>IVA:</span>
                      <span>${{costBreakdown.ivaAmount.toFixed(2)}}</span>
                    </div>
                    <div *ngIf="costBreakdown.ivaAmount > 0" class="breakdown-item total">
                      <span>Total final:</span>
                      <span>${{costBreakdown.finalTotalCost.toFixed(2)}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="double-fields">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Rango horario de retiro</mat-label>
                <input
                  matInput
                  formControlName="pickupTimeRange"
                  [placeholder]="pickupTimeRangePlaceholder"
                />
                <span matSuffix>{{ hourSuffix }}</span>
                <mat-error
                  *ngIf="
                    addressForm.get('pickupTimeRange')?.hasError('required')
                  "
                >
                  El rango horario de retiro es requerido
                </mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Rango horario de entrega</mat-label>
                <input
                  matInput
                  formControlName="deliveryTimeRange"
                  [placeholder]="deliveryTimeRangePlaceholder"
                />
                <span matSuffix>{{ hourSuffix }}</span>
                <mat-error
                  *ngIf="
                    addressForm.get('deliveryTimeRange')?.hasError('required')
                  "
                >
                  El rango horario de entrega es requerido
                </mat-error>
              </mat-form-field>
            </div>

            <div class="double-fields">
              <mat-form-field appearance="outline">
                <mat-label>Teléfono de retiro</mat-label>
                <input 
                  matInput
                  formControlName="pickupPhone"
                  placeholder="Ingrese el teléfono de retiro"
                  required
                  maxlength="15"
                />
                <mat-error
                  *ngIf="
                    addressForm.get('pickupPhone')?.hasError('required')
                  "
                >
                  El teléfono de retiro es requerido. Debe tener entre 10 y 15 dígitos.
                </mat-error>
                  
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Teléfono de entrega</mat-label>
                <input 
                  matInput
                  formControlName="deliveryPhone"
                  placeholder="Ingrese el teléfono de entrega"
                  required
                />
                <mat-error
                  *ngIf="
                    addressForm.get('deliveryPhone')?.hasError('required')
                  "
                >
                  El teléfono de entrega es requerido. Debe tener entre 10 y 15 dígitos.
                </mat-error>
              </mat-form-field>
            </div>

            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Observaciones</mat-label>
              <textarea
                matInput
                formControlName="observations"
                placeholder="Ingrese observaciones"
              ></textarea>
            </mat-form-field>

            <label class="mat-label" style="margin-top: 10px; display: block"
              >¿Dónde se paga?</label
            >
            <mat-radio-group
              formControlName="paymentLocation"
              class="full-width"
              style="margin-bottom: 16px; display: flex; flex-direction: row"
            >
              <mat-radio-button value="Destino" style="margin-right: 16px"
                >En la entrega</mat-radio-button
              >
              <mat-radio-button value="Entrega" style="margin-right: 16px"
                >En el retiro</mat-radio-button
              >
              <mat-radio-button value="Cuenta">A cuenta</mat-radio-button>
            </mat-radio-group>
            <div class="button-container">
              <!-- Botones de la izquierda -->
              <div class="left-buttons" *ngIf="isEditMode">
                <button
                  mat-raised-button
                  color="warn"
                  type="button"
                  (click)="onCancelShipment()"
                >
                  Cancelar envío
                </button>
                <button
                  mat-raised-button
                  color="accent"
                  type="button"
                  style="margin-left: 12px"
                  (click)="onFinalizeShipment()"
                  [disabled]="!canFinalizeShipment()"
                  [matTooltip]="!canFinalizeShipment() ? 'El pedido debe estar aceptado o en curso para poder finalizarse' : ''"
                >
                  Finalizar envío
                </button>
              </div>
              
              <!-- Botones de la derecha -->
              <div class="right-buttons">
                <button
                  mat-raised-button
                  color="warn"
                  type="button"
                  (click)="onCancel()"
                >
                  Salir sin guardar
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  style="margin-left: 12px"
                  [disabled]="addressForm.invalid"
                >
                  {{ isEditMode ? 'Guardar cambios' : 'Registrar envío' }}
                </button>
              </div>
            </div>
          </form>
        </mat-card>
      </div>
    </div>
  </div>
</div>
